import * as React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

import CookiePolicyContent, {
  ICookiePolicyContentStateProps,
  ICookiePolicyContentDispatchProps,
} from './cookiePolicy/CookiePolicyContent';

export interface ICookiePolicyStateProps
  extends ICookiePolicyContentStateProps {}
export interface ICookiePolicyDispatchProps
  extends ICookiePolicyContentDispatchProps {}

const CookiePolicy: React.FC<
  ICookiePolicyStateProps & ICookiePolicyDispatchProps
> = ({ html, openCookieSettings }) => {
  const { t } = useTranslation();
  return (
    <div className='pt-2'>
      <h1 className='text-center fcolor--primary-brand my-2'>{t('title')}</h1>
      <Helmet>
        <title>{t('cookiePolicy_title')}</title>
      </Helmet>
      <CookiePolicyContent
        html={html}
        openCookieSettings={openCookieSettings}
      />
    </div>
  );
};

export default CookiePolicy;
